import { Button, Modal } from '@dev-spendesk/grapes';
import { type MouseEventHandler } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { useWorkflowContext } from '../../state/WorkflowContext';

type Props = {
  isOpen: boolean;
  onCloseModal: MouseEventHandler<HTMLElement>;
  onConfirm: MouseEventHandler<HTMLElement>;
};
export const NodeDeleteConfirmationModal = ({
  isOpen,
  onCloseModal,
  onConfirm,
}: Props) => {
  const { t } = useTranslation('global');
  const { selectedNodeId, getChildrenNodes } = useWorkflowContext();
  const childrenNodes = selectedNodeId && getChildrenNodes(selectedNodeId);

  return (
    <Modal
      title={t('approvalWorkflows.deleteNode.title')}
      iconName={childrenNodes && childrenNodes.length > 0 ? 'trash' : 'sparkle'}
      iconVariant={
        childrenNodes && childrenNodes.length > 0 ? 'warning' : 'info'
      }
      actions={[
        <Button
          key="secondary"
          type="button"
          variant="secondaryNeutral"
          onClick={(event) => {
            onCloseModal(event);
          }}
          text={t('approvalWorkflows.deleteNode.buttons.cancel')}
        />,
        <Button
          key="primary"
          type="button"
          variant={
            childrenNodes && childrenNodes.length > 0
              ? 'primaryWarning'
              : 'primaryBrand'
          }
          text={t('approvalWorkflows.deleteNode.buttons.confirm')}
          onClick={(event) => {
            onConfirm(event);
          }}
        />,
      ]}
      isOpen={isOpen}
    >
      {childrenNodes && childrenNodes.length > 0 ? (
        <div>
          {t('approvalWorkflows.deleteNode.contentChildren', {
            count: childrenNodes.length,
          })}
        </div>
      ) : (
        <div>{t('approvalWorkflows.deleteNode.content')}</div>
      )}
    </Modal>
  );
};
